"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRecurringPaymentEnabled = void 0;
var isRecurringPaymentEnabled = function (paymentSettings) {
    var _a;
    return Boolean((paymentSettings === null || paymentSettings === void 0 ? void 0 : paymentSettings.enabled) &&
        !paymentSettings.partialPaymentConfig.enabled &&
        ((_a = paymentSettings.recurringConfig) === null || _a === void 0 ? void 0 : _a.enabled));
};
exports.isRecurringPaymentEnabled = isRecurringPaymentEnabled;
